import React, { useMemo } from 'react';
import { Typography, Row, Col } from 'antd';
import { Colors } from '@common/tokens';
import { CSVError } from 'works/legacy/lib/csv-error';

const { Title, Text } = Typography;

const errorLabels: { [key: string]: string } = {
  blank: 'Missing Data',
  invalid: 'Invalid Data',
  unauthorized: 'Permissioning Issues',
};

type Props = {
  errors: CSVError[];
};

export function ShiftsAddMultipleReviewErrors({ errors }: Props) {
  const groupedErrors = useMemo(
    () =>
      errors.reduce(
        (
          acc: { [type: string]: { [row: number]: CSVError[] } },
          current: CSVError
        ) => {
          if (!acc[current.type]) {
            acc[current.type] = {};
          }

          if (!acc[current.type][current.row]) {
            acc[current.type][current.row] = [];
          }

          acc[current.type][current.row].push(current);

          return acc;
        },
        {}
      ),
    [errors]
  );

  const renderMessage = ({ message }: { message: string }) => (
    <Row key={message}>
      <Col>
        <Text>{message}</Text>
      </Col>
    </Row>
  );

  const renderRow = ([row, errors]: [string, CSVError[]]) => (
    <Row key={row} gutter={[0, 8]}>
      <Col span={3}>
        <Text style={{ color: Colors.midnightLighter }}>Row {row}</Text>
      </Col>
      <Col span={21}>{errors.map(renderMessage)}</Col>
    </Row>
  );

  return (
    <div>
      {Object.entries(groupedErrors).map(([type, rows]) => (
        <div key={type}>
          <Title level={2}>{errorLabels[type]}</Title>
          {Object.entries(rows).map(renderRow)}
        </div>
      ))}
    </div>
  );
}
